import * as yup from 'yup';
import { TFunction } from 'react-i18next';

export const AdminForm = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema-consumptionsReport-form-venueId-required')),
    commerceId: yup.string().required(t('schema-consumptionsReport-form-commerceId-required')),
    productsIds: yup.array().of(yup.string()).required(t('schema-consumptionsReport-form-commerceId-required')),
  });
